import { PipeTransform, Pipe, LOCALE_ID, Inject } from '@angular/core';
import { formatNumber } from '@angular/common';
import { PCNT_FORMAT } from '../models/data-format';

@Pipe({ name: 'Pcnt' })
export class PcntPipe implements PipeTransform {
  constructor(
    @Inject(LOCALE_ID) private locale: string,
    @Inject(PCNT_FORMAT) private pcntFormat: string
  ) {
  }
  transform(value: any, showPcnt?: boolean, total?: number) {
    if (!showPcnt) {
      return value;
    }
    else {
      if (total <= 0) {
        return value;
      } else {
        // `{minIntegerDigits}.{minFractionDigits}-{maxFractionDigits}`
        return formatNumber(value * 100 / total, this.locale, `1.${this.pcntFormat || '1'}-${this.pcntFormat || '1'}`) + '%';
      }
    }

  }
}
